import Dollar from '../assets/icons/dollor'
import TradeInExecutionIcon from '../assets/icons/tradeInExecutionIcon'
import ReturnsIcon from '../assets/icons/returnsIcon'
import MonetizeDeviceIcon from "../assets/icons/monetizeDeviceIcon";
import DeviceRecieptIcon from "../assets/icons/deviceRecieptIcon";
import SettlementIcon from "../assets/icons/settlementIcon";
import CutomerInquiriesIcon from "../assets/icons/cutomerInquiriesIcon";
import EnrollmentIcon from "../assets/icons/enrollmentIcon";
import DeviceRegIcon from "../assets/icons/deviceRegIcon";
import ClaimsIcon from "../assets/icons/claimsIcon";
import FulfillmentIcon from "../assets/icons/fulfillmentIcon";
import starhubUserManual from "../assets/wordFiles/Starhub_Reporting_tool-Device_protection_plan_User_Manual.docx";
import celcomUserManual from "../assets/wordFiles/Celcom_Reporting_tool_Phone_Care_User_Manual.docx";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


export const getGuageIcons = (metricsLabel, secondaryColor) => {
  switch (metricsLabel?.toUpperCase()){
    case 'TRADE IN EXECUTION':
      return <TradeInExecutionIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'SUBSCRIPTION':
        return <TradeInExecutionIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'CONFIGURATION':
      return <TradeInExecutionIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />  
    case 'RETURNS':
      return <ReturnsIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'SERVICE REQUEST':
      return <ReturnsIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'DEVICE RETURNS':
    case 'SMARTSTOCK CONFIG':
    case 'LFL':
    case 'LAYERED RPM':
    case 'UPGRADE':
    case 'DOWNGRADE':
    case'BACKORDER':
    case 'SERVICE FEE':
    // case 'NPS':
      return <ReturnsIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />  
    case 'DEVICE RECEIPT':
      return <DeviceRecieptIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'DEVICE PROCESSING':
      return <DeviceRecieptIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />  
    case 'MONETISATION':
    case 'MONETIZE DEVICE':
      return <MonetizeDeviceIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'CHARGES($)':
      return <Dollar className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'CHARGES':
      return <Dollar className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'SERVICE REQUEST REVENUE':
      return <Dollar className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'SETTLEMENT':
      return <SettlementIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'NPS':
      return <SettlementIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'CUSTOMER INQUIRIES':
      return <CutomerInquiriesIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'ENROLMENT':
      return <EnrollmentIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'DEVICE REGISTRATION':
      return <DeviceRegIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'CLAIMS':
      return <ClaimsIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    case 'FULFILLMENT REPAIR':
    case 'FULFILLMENT':
    case 'FULFILMENT REPLACE':
    case 'FULFILLMENT BUYOUT': 
      return <FulfillmentIcon className="m-0 h-7 w-7 mr-2" stroke={secondaryColor} />
    default:
      break;
  }
}

export const getMyColors = (index) => {
  let primary = "#000000";
  let secondary = "#000000";
  let text = "#FFFFFF";
  switch (index) {
    case 0:
      primary = "#8223D2";
      secondary = "#D648FD";
      break;
    case 1:
      primary = "#6E767D";
      secondary = "#D5D6DA";
      text = "#000000";
      break;
    case 2:
      primary = "#00B574";
      secondary = "#1DFFBA";
      text = "#000000";
      break;
    case 3:
      primary = "#4A68F9";
      secondary = "#00B9FD";
      break;
    case 4:
      primary = "#82A700";
      secondary = "#D2FA46";
      text = "#000000";
      break;
    case 5:
      primary = "#A839F3";
      secondary = "#32E7FF";
      break;
    case 6:
      primary = "#9F0000";
      secondary = "#3CAFF7";
      break;
    case 7:
      primary = "#8223D2";
      secondary = "#D648FD";
      break;
    case 8:
      primary = "#6E767D";
      secondary = "#D5D6DA";
      text = "#000000";
      break;
    default:
      break;
  }
  return { primary, secondary, text };
};

export const isEmpty = (input) => {
  if (typeof input === "undefined" || input === "null") {
    return true;
  }
  if (typeof input === "function") {
    return false;
  }
  if (Array.isArray(input)) {
    return input.length === 0;
  }
  return !input || Object.keys(input).length === 0;
};

export const getUniqueValuesFromArray = (array, key) => {
  return array?.filter(
    (asp, index, self) => self.findIndex((a) => a[key] === asp[key]) === index
  );
};

// export const sanitize = (value) => {
//   return DOMPurify.sanitize(value);
// };

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const getParameterByName = (name, url = window.location.href) => {
  // name = name.replace(/[\[\]]/g, "\\$&");
  // var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  //   results = regex.exec(url);
  // if (!results) return null;
  // if (!results[2]) return "";
  // return decodeURIComponent(results[2]?.replace(/\+/g, " "));
  if(!url) url = window.location.search;
  var query = url.substr(1);
  var result = {};
  query.split("&").forEach(function(part) {
    var item = part.split("=");
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
};

export const numberWithCommas = (number) => {
  return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const toPascalCase = (str) => {
  return str?.replace(/\w\S*/g, (t) => {
    return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase()
  })
}
export const getResource = (resources, key) => {
  return resources[key] || key
}


export const setCursorPositioning = (event) => {
  // To get scroll element coordinates
  const left = document.documentElement.scrollLeft;
  const top = document.documentElement.scrollTop;

  // Current cursor position
  let x = event.pageX;
  let y = event.pageY;

  // Determining if scroll is present, subtract values from actual cursor position
  top > 0 && (y -= top);
  left > 0 && (x -= left);

  // Setting up dynamic property so that animation can start and end from our cursor position
  document.documentElement.style.setProperty(
    "--modal-origin",
    `${x}px ${y}px`
  );
};

export const getTypeIndicator = (type, country) => {
  switch(type){
    case 'Currency_Sum':
      return country?.toLowerCase() === 'thailand' ? "฿" : country?.toLowerCase() === 'malaysia' ? 'MYR' : country?.toLowerCase() === 'singapore' ? '$' : "$"
    default:
      return ""
  }
}

export const getSSTypeIndicator = (type, country) => {
  switch(type){
    case 'Currency_Sum':
      return "฿"
    default:
      return ""
  }
}

export const getApplicableSections = (sectionsList, sectionName) => {
  return sectionsList?.filter((section) => section === sectionName)?.length > 0 ? true : false;
}

export const sortByMonthChartData = (data) => {
  return data.sort((a, b) => {
      if (!a.Month) return 1;
      if (!b.Month) return -1;
      return new Date(a.Month) - new Date(b.Month);
  });
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
          const reader = fileReader.result;
          const readerfinal = reader?.split('base64,');
          resolve(readerfinal[1]);
      };

      fileReader.onerror = (err) => {
          reject(err);
      };
  });
};

export const getUserManuals = (carrier) => {
    switch(carrier){
      case 'starhub':
        return starhubUserManual;
      case 'celcom':
        return celcomUserManual;
    }
};

export const sortTenureCategoriesForCustValMgmt = (categories) => {
  return categories.sort((a, b) => {
      const getMinValue = (str) => {
          const match = str.match(/\d+/g);
          return match ? parseInt(match[0], 10) : 0;
      };

      return getMinValue(a) - getMinValue(b);
  });
};

export const sortByMonthsSalesReport = (data) => {
  return data.sort((a, b) => new Date(a.Months.slice(0, 4), a.Months.slice(4, 6) - 1) - new Date(b.Months.slice(0, 4), b.Months.slice(4, 6) - 1));
};

export const displayPgmName = (pgmName) => {
  switch (pgmName?.toLowerCase()) {
    case 'program summary':
      return 'Program Overview';
    case 'real time service request report':
      return 'Real Time Service Request Status';
    case 'customer service sla report':
        return 'Customer SLA';
    case 'technical service sla report':
      return 'Technical SLA';
    case 'finance reconciliation & invoice':
      return 'Finance & Incentive Reports';
  }
}

// export const exportChartGraph = (e, section, fileName) => {
//   const but = e.target;
//   but.style.display = "none";
//   let input = window.document.getElementsByClassName(section)[0];        

//   html2canvas(input, { scale: 1 }).then((canvas) => {
//     const img = canvas.toDataURL("image/png");
//     const imgWidth = canvas.width / 2;
//     const imgHeight = canvas.height / 2;

//     const pdf = new jsPDF("l", "pt", [imgWidth, imgHeight]);

//     pdf.addImage(img, "PNG", 0, 0, imgWidth, imgHeight);
//     pdf.save(`${fileName}.pdf`);
//     but.style.display = "block";
//   });
// };

export const exportChartGraph = (e, section, fileName) => {
  const but = e.target;
  but.style.display = "none";
  let input = window.document.getElementsByClassName(section)[0];

  html2canvas(input, { scale: 1.5 }).then((canvas) => {
    const img = canvas.toDataURL("image/jpeg", 0.6);

    const imgWidth = 595.28;
    const pageHeight = 841.89;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;

    const pdf = new jsPDF("p", "pt", "a4");
    let position = 0;

    pdf.addImage(img, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(img, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(`${fileName}.pdf`);
    but.style.display = "block";
  });
};